import { defineStore } from 'pinia';
export default defineStore({
  id: 'config',

  state: () => ({
    theConfig: null,
    langs: [
      { id: 'en', name: 'EN' },
      { id: 'fr', name: 'FR' },
    ],
  }),

  getters: {
    config() {
      let config = localStorage.getItem('project-config');
      this.theConfig = config ? JSON.parse(config) : null;
      return this.theConfig;
    },
    sidebarExpanded() {
      return this.config ? this.config.sidebarExpanded : true;
    },
    currentLang() {
      const currentLang = this.config ? this.config.lang : 'en';
      return this.langs.find((l) => l.id == currentLang) || this.langs[0];
    },
  },

  actions: {
    async setConfig(payload) {
      payload = this.config ? { ...this.theConfig, ...payload } : payload;
      localStorage.setItem('project-config', JSON.stringify(payload));
      this.theConfig = payload;
    },
  },
});
